import { Component } from '@angular/core';
import { AuthService } from '../../../services/auth/auth-service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent {
  constructor(private readonly authService: AuthService) {}

  public login(isRegister: boolean = false) {
    return this.authService.login(isRegister);
  }
}
